import { Box, Card, CardContent, CircularProgress, Grid } from "@material-ui/core";
import * as React from "react";
import {
  AutocompleteInput,
  Button,
  Create,
  ReferenceInput,
  TextInput,
  Toolbar,
  required,
  useNotify,
} from "react-admin";
import CustomerSelect from "../../../Components/CustomerSelect/CustomerSelect";
import { Form } from "react-final-form";
import { Add } from "@material-ui/icons";
import { useVerifyPermission } from "@airborne/react-admin";
import { useAppDataProvider } from "../../../dataprovider";
import { ShippingAddressCreateModel } from "../../../Pages/RequestOrder/Models/ShippingAddressCreateModel";
import { useHistory } from "react-router-dom";

const textInputStyle = { marginRight: "8px" };

const ShippingAddressCreate = props => {
  useVerifyPermission("shippingaddresss", "create");
  const [loading, setLoading] = React.useState(false);
  const notify = useNotify();
  const dataProvider = useAppDataProvider();
  const history = useHistory();

  const handleSubmit = async e => {
    let postModel: ShippingAddressCreateModel = {
      AirportCode: e.airportCode,
      AttentionName: e.attentionName,
      AttentionPhone: e.attentionPhone,
      ConsigneeAddress: e.consigneeAddress,
      ConsigneeName: e.consigneeName,
      Email: e.email,
      ShipAddress: e.shipAddress,
      CustomerId: e.customer.ownercode,
    };

    setLoading(true);
    dataProvider
      .postShippingAddress(postModel)
      .then(result => {
        notify(`Record created`, "success", false, true);
        history.push("/shippingaddresss/" + result?.data?.id);
      })
      .catch(error => {
        notify(`${error}`, "error", false, true);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Create title={"Shipping Address Create"} component="div" {...props}>
      <Form
        {...props}
        onSubmit={handleSubmit}
        render={({ form, handleSubmit }) => {
          return (
            <>
              <Card>
                <form>
                  <CardContent>
                    <Grid container spacing={2} direction="row">
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        <CustomerSelect
                          validate={required()}
                          source="customer.ownercode"
                          label="Customer"
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        <ReferenceInput
                          validate={required()}
                          label="Airport Code"
                          source="airportCode"
                          reference="cdmlocations"
                          translateChoice={false}
                          filterToQuery={searchText => ({ id__contains: searchText })}
                          sort={{ field: "id", order: "ASC" }}
                          fullWidth
                        >
                          <AutocompleteInput
                            optionText="id"
                            optionValue="id"
                            variant="outlined"
                            resettable
                            fullWidth
                            validate={required()}
                          />
                        </ReferenceInput>
                      </Grid>
                    </Grid>
                    <Box display="flex" justifyContent="space-between" mb={2}>
                      <TextInput
                        validate={required()}
                        source="attentionName"
                        label="Attention Name"
                        fullWidth
                        style={textInputStyle}
                        variant="outlined"
                      />
                      <TextInput
                        validate={required()}
                        source="attentionPhone"
                        label="Attention Phone"
                        fullWidth
                        style={textInputStyle}
                        variant="outlined"
                      />
                    </Box>

                    <Box display="flex" justifyContent="space-between" mb={2}>
                      <TextInput
                        validate={required()}
                        source="consigneeName"
                        label="Company/Consignee Name"
                        fullWidth
                        style={textInputStyle}
                        variant="outlined"
                      />
                      <TextInput
                        validate={required()}
                        source="email"
                        label="E-mail"
                        type="email"
                        fullWidth
                        style={textInputStyle}
                        variant="outlined"
                      />
                    </Box>

                    <Box display="flex" justifyContent="space-between" mb={2}>
                      <TextInput
                        validate={required()}
                        source="consigneeAddress"
                        label="Company/Consignee Address"
                        fullWidth
                        style={textInputStyle}
                        multiline
                        resettable
                        variant="outlined"
                      />
                      <TextInput
                        validate={required()}
                        source="shipAddress"
                        label="Shipping Address"
                        fullWidth
                        style={textInputStyle}
                        multiline
                        resettable
                        variant="outlined"
                      />
                    </Box>
                  </CardContent>
                  <Toolbar {...props} placeholder="">
                    <Button
                      label={loading ? "Address is creating!" : "Create"}
                      disabled={loading}
                      size="medium"
                      variant="contained"
                      style={{ margin: "8px" }}
                      onClick={() => handleSubmit()}
                    >
                      {loading ? <CircularProgress size="2rem" color="secondary" /> : <Add />}
                    </Button>
                  </Toolbar>
                </form>
              </Card>
            </>
          );
        }}
      />
    </Create>
  );
};

export default ShippingAddressCreate;
